export const dimension = {
  upper: {
    width: '1930px',
    height: '1200px',
  },
  lowerMonitorSize: {
    width: '1930px',
    height: '1200px',
  },
  lowerMonitorDisplayArea: {
    width: '1600px',
    height: '1200px',
  },
  lowerMonitorLeftStrip: {
    width: '150px',
    height: '1200px',
  },
  lowerMonitorRightStrip: {
    width: '180px',
    height: '1200px',
  },
  upperMonitorLeftStrip: {
    width: '150px',
    height: '1200px',
  },
  upperMonitorRightStrip: {
    width: '180px',
    height: '1200px',
  },
  upperStrap: {
    height: '90px',
    width: '100%',
  },

  desk: {
    width: '1920px',
    height: '1080px',
  },

  generalDisplayArea: {
    height: '1110px',
    width: '1200px',
  },
  closeControlArea: {
    width: '100%',
    height: '330px',
  },
  roleAssignmentArea: {
    width: '400px',
    height: '110px',
  },
  alertArea: {
    width: '400px',
    height: '140px',
  },
  sistema: {
    roleInfoArea: {
      width: '300px',
      height: '100%',
    },
    csraArea: {
      width: '480px',
      height: '100%',
    },
    upperSpareArea: {
      width: '820px',
      height: '100%',
    },
    shipInfoArea: {
      width: '480px',
      height: '100%',
    },
    lowerSpareArea: {
      width: '160px',
      height: '100%',
    },
    cursorInfoArea: {
      width: '260px',
      height: '100%',
    },
    auxInfoArea: {
      width: '400px',
      height: '100%',
    },
  },
  sonar: {
    roleInfoArea: {
      width: '300px',
      height: '100%',
    },
    workModeArea: {
      height: '100%',
      width: '480px',
    },
    csraArea: {
      height: '100%',
      width: '160px',
    },
    shipInfoArea: {
      width: '160px',
      height: '100%',
    },
    cursorInfoArea: {
      height: '100%',
      width: '260px',
    },
    audioInfoArea: {
      height: '100%',
      width: '200px',
    },
    auxInfoArea: {
      height: '100%',
      width: '200px',
    },

    dataEntryArea: {
      width: '400px',
      height: '640px',
    },
    dataEntryAreaUpper: {
      width: '400px',
      height: '670px',
    },
  },
  tactico: {
    roleInfoArea: {
      width: '300px',
      height: '100%',
    },
    csraArea: {
      height: '100%',
      width: '480px',
    },
    spareArea: {
      width: '420px',
      height: '100%',
    },
    auxInfoArea: {
      width: '400px',
      height: '100%',
    },
    shipInfoArea: {
      width: '480px',
      height: '100%',
    },
  },
  link: {
    roleInfoArea: {
      width: '300px',
      height: '100%',
    },
    linkStatusArea: {
      height: '100%',
      width: '210px',
    },
    lowerSpareArea: {
      width: '160px',
      height: '100%',
    },
    auxInfoArea: {
      width: '400px',
      height: '100%',
    },
    shipInfoArea: {
      width: '480px',
      height: '100%',
    },
    upperSpareArea: {
      width: '1300px',
      height: '100%',
    },
  },
  obt: {
    roleInfoArea: {
      width: '300px',
      height: '100%',
    },
    upperSpareArea: {
      width: '1300px',
      height: '100%',
    },
    shipInfoArea: {
      width: '480px',
      height: '100%',
    },
    lowerSpareArea: {
      width: '160px',
      height: '100%',
    },
    cursorInfoArea: {
      width: '260px',
      height: '100%',
    },
    auxInfoArea: {
      width: '400px',
      height: '100%',
    },
  },
  weapon: {
    roleInfoArea: {
      width: '300px',
      height: '100%',
    },
    shipInfoArea: {
      width: '1300px',
      height: '100%',
    },
    csraArea: {
      width: '1300px',
      height: '100%',
    },
  },
  prelimiaryHookArea: {
    width: '160px',
  },
  generalInfoArea: {
    width: '400px',
  },
  ballTabPosition: {
    width: '170px',
  },
};

export const colors = {
  border: 'rgb(106,121,143)',
  black: 'black',
  white: 'white',
  primary: 'rgb(32, 42, 71)',
  secondary: `rgb(18,22,65)`,
  specialInputFocus: 'rgb(73,144,149)',
  inputBackground: 'rgb(19,23,62)',
  yellowText: 'rgb(234, 239, 12);',
  greenText: 'rgb(167, 239, 115)',
  red: 'rgb(255, 0, 0)',
  analogStripBackground: 'rgb(110,92,54)',
  monitorLedOffColor: 'rgb(79,86,49)',
  monitorLedOnColor: 'rgb(253,199,11)',
  rightStripRedOnColor: 'rgb(143,52,32)',
  rightStripRedOffColor: 'rgb(252,0,7)',
  rightStripGreenOnColor: 'rgb(188,255,40)',
  rightStripGreenOffColor: 'rgb(156,117,26)',
  ledSwitchOnColor: 'rgb(235,255,105)',
  popupBorderColor: 'rgb(153, 160, 174)',
  popupMenuHoverColor: '#374058',
};
